export const Button = ({ children, type = 'button', onClick, disabled = false, className = '', variant = 'primary' }) => (
  <button type={type} onClick={onClick} disabled={disabled} className={`btn btn-${variant} ${className} ${disabled ? 'btn-disabled' : ''}`}>
    {children}
  </button>
);
